/* eslint-disable import/no-named-as-default-member */
export enum DateFormat {
  TIME_24 = 'HH:mm',
  DATE = 'DD/MM/YYYY',
  DATE_TIME_24 = 'DD/MM/YYYY HH:mm',
}

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isToday from 'dayjs/plugin/isToday'; // ES 2015

// Extend Day.js with the duration plugin
dayjs.extend(duration);
dayjs.extend(isToday);

export const formatUnixTime = (
  time: number,
  format: DateFormat = DateFormat.DATE
): string => {
  return dayjs.unix(time).format(format);
};

export const formatSecondsToHHmm = (seconds: number): string => {
  // Create a duration object from seconds
  const timeDuration = dayjs.duration(seconds, 'seconds');

  // Format the duration into HH:mm
  return timeDuration.format(DateFormat.TIME_24);
};

export { dayjs };
